import {isNotNil} from 'ramda';

export const getTreeFolderQueryModifier = (
  treeFolderId: string | undefined,
  includeSubfolders: boolean
) => ({
  treeFolderIds: includeSubfolders && isNotNil(treeFolderId) ? [treeFolderId] : undefined,
  treeFolderId: !includeSubfolders && isNotNil(treeFolderId) ? treeFolderId : undefined,
});
